// Config object to be passed to Msal on creation

let clientId = "2fe1b422-7c33-4fc1-8e27-45512bee3023";
let tenantId = "770e7725-56ca-4480-935d-e8621263c85f";
let redirectUri = "https://qaagentportal.insuredmine.com/agent/session/loginone";
let host = window.location.host;
let weinsure_domains = [
    'weinsurellc.insuredmine.com', 
    'weinsuregroup.insuredmine.com',
    "weinsuregroup103.insuredmine.com",
    "weinsuregroup104.insuredmine.com",
    "weinsuregroup105.insuredmine.com",
    "weinsuregroup106.insuredmine.com",
    "weinsuregroup107.insuredmine.com",
    "weinsuregroup109.insuredmine.com",
    "weinsuregroup110.insuredmine.com",
    "weinsuregroup111.insuredmine.com",
    "weinsuregroup112.insuredmine.com",
    "weinsuregroup113.insuredmine.com",
    "weinsuregroup114.insuredmine.com",
    "weinsuregroup115.insuredmine.com",
    "weinsuregroup117.insuredmine.com",
    "weinsuregroup119.insuredmine.com",
    "weinsuregroup120.insuredmine.com",
    "weinsuregroup122.insuredmine.com",
    "weinsuregroup124.insuredmine.com",
    "weinsuregroup125.insuredmine.com",
    "weinsuregroup126.insuredmine.com",
    "weinsuregroup127.insuredmine.com",
    "weinsuregroup130.insuredmine.com",
    "weinsuregroup131.insuredmine.com",
    "weinsuregroup132.insuredmine.com",
    "weinsuregroup133.insuredmine.com",
    "weinsuregroup135.insuredmine.com",
    "weinsuregroup137.insuredmine.com",
    "weinsuregroup138.insuredmine.com",
    "weinsuregroup139.insuredmine.com",
    "weinsuregroup142.insuredmine.com",
    "weinsuregroup147.insuredmine.com",
    "weinsuregroup148.insuredmine.com",
    "weinsuregroup149.insuredmine.com",
    "weinsuregroup151.insuredmine.com",
    "weinsuregroup152.insuredmine.com",
    "weinsuregroup155.insuredmine.com",
    "weinsuregroup162.insuredmine.com",
    "weinsuregroup164.insuredmine.com",
    "weinsuregroup165.insuredmine.com",
    "weinsuregroup167.insuredmine.com",
    "weinsuregroup169.insuredmine.com",
    "weinsuregroup170.insuredmine.com",
    "weinsuregroup172.insuredmine.com",
    "weinsuregroup173.insuredmine.com",
    "weinsuregroup175.insuredmine.com",
    "weinsuregroup177.insuredmine.com",
    "weinsuregroup181.insuredmine.com",
    "weinsuregroup185.insuredmine.com",
    "weinsuregroup191.insuredmine.com",
    "weinsuregroup192.insuredmine.com",
    "weinsuregroup193.insuredmine.com",
    "weinsuregroup200.insuredmine.com",
    "weinsuregroup202.insuredmine.com",
    "weinsuregroup203.insuredmine.com",
    "weinsuregroup210.insuredmine.com",
    "weinsuregroup214.insuredmine.com",
    "weinsuregroup219.insuredmine.com",
    "weinsuregroup222.insuredmine.com",
    "weinsuregroup223.insuredmine.com",
    "weinsuregroup227.insuredmine.com",
    "weinsuregroup237.insuredmine.com",
    "weinsuregroup239.insuredmine.com",
    "weinsuregroup240.insuredmine.com",
    "weinsuregroup241.insuredmine.com",
    "weinsuregroup243.insuredmine.com",
    "weinsuregroup245.insuredmine.com",
    "weinsuregroup247.insuredmine.com",
    "weinsuregroup249.insuredmine.com",
    "weinsuregroup251.insuredmine.com",
    "weinsuregroup256.insuredmine.com",
    "weinsuregroup257.insuredmine.com",
    "weinsuregroup261.insuredmine.com",
    "weinsuregroup263.insuredmine.com",
    "weinsuregroup270.insuredmine.com",
    "weinsuregroup271.insuredmine.com",
    "weinsuregroup277.insuredmine.com",
    "weinsuregroup280.insuredmine.com",
    "weinsuregroup283.insuredmine.com",
    "weinsuregroup295.insuredmine.com",
    "weinsuregroup302.insuredmine.com",
    "weinsuregroup303.insuredmine.com",
    "weinsuregroup308.insuredmine.com",
    "weinsuregroup316.insuredmine.com",
    "weinsuregroup318.insuredmine.com",
    "weinsuregroup319.insuredmine.com",
    "weinsuregroup321.insuredmine.com",
    "weinsuregroup330.insuredmine.com",
    "weinsuregroup337.insuredmine.com",
    "weinsuregroup338.insuredmine.com",
    "weinsuregroup343.insuredmine.com",
    "weinsuregroup345.insuredmine.com",
    "weinsuregroup347.insuredmine.com",
    "weinsuregroup348.insuredmine.com",
    "weinsuregroup372.insuredmine.com",
    "weinsuregroup375.insuredmine.com",
    "weinsuregroup450.insuredmine.com",
    "weinsuregroup453.insuredmine.com",
    "weinsuregroup455.insuredmine.com",
    "weinsuregroup457.insuredmine.com",
    "weinsuregroup460.insuredmine.com",
    "weinsuregroup108.insuredmine.com",
    "weinsuregroup146.insuredmine.com",
    "weinsuregroup153.insuredmine.com",
    "weinsuregroup156.insuredmine.com",
    "weinsuregroup157.insuredmine.com",
    "weinsuregroup159.insuredmine.com",
    "weinsuregroup160.insuredmine.com",
    "weinsuregroup161.insuredmine.com",
    "weinsuregroup201.insuredmine.com",
    "weinsuregroup216.insuredmine.com",
    "weinsuregroup221.insuredmine.com",
    "weinsuregroup229.insuredmine.com",
    "weinsuregroup236.insuredmine.com",
    "weinsuregroup238.insuredmine.com",
    "weinsuregroup242.insuredmine.com",
    "weinsuregroup244.insuredmine.com",
    "weinsuregroup248.insuredmine.com",
    "weinsuregroup250.insuredmine.com",
    "weinsuregroup258.insuredmine.com",
    "weinsuregroup265.insuredmine.com",
    "weinsuregroup269.insuredmine.com",
    "weinsuregroup272.insuredmine.com",
    "weinsuregroup276.insuredmine.com",
    "weinsuregroup279.insuredmine.com",
    "weinsuregroup286.insuredmine.com",
    "weinsuregroup291.insuredmine.com",
    "weinsuregroup298.insuredmine.com",
    "weinsuregroup306.insuredmine.com",
    "weinsuregroup310.insuredmine.com",
    "weinsuregroup312.insuredmine.com",
    "weinsuregroup314.insuredmine.com",
    "weinsuregroup326.insuredmine.com",
    "weinsuregroup327.insuredmine.com",
    "weinsuregroup331.insuredmine.com",
    "weinsuregroup336.insuredmine.com",
    "weinsuregroup339.insuredmine.com",
    "weinsuregroup363.insuredmine.com",
    "weinsuregroup366.insuredmine.com",
    "weinsuregroup456.insuredmine.com",
    "weinsuregroup462.insuredmine.com",
    "weinsuregroup463.insuredmine.com",
    "weinsuregroup467.insuredmine.com"
]
// gwicfe prodEnvironmentConfig ---start
if (host == 'sunstarinsurance.insuredmine.com'){
    clientId = "40502ba5-dac7-477a-944c-17e9686293c9";
    tenantId = "52ac7a8a-923e-4cb5-87de-6b9e3945cb51";
    redirectUri = "https://sunstarinsurance.insuredmine.com/agent/session/loginone";
}
else if (host == 'craneagency.insuredmine.com'){
    clientId = "e70cf7dd-4c66-4193-b154-6924b0616a2e";
    tenantId = "3b711f1f-4fb3-4613-ac66-1c82a69ab84c";
    redirectUri = "https://craneagency.insuredmine.com/agent/session/loginone";
}
else if (weinsure_domains.includes(host)) {
    clientId = "c1de36a5-7ea0-43bd-8922-36b5f6de2011";
    tenantId = "5b83f627-aaa6-4678-aac0-261244194361";
    redirectUri = `https://${host}/agent/session/loginone`;
}
else if (host == 'higusa.insuredmine.com'){
    clientId = "137c2854-c7bb-4d05-a64f-035e15c1004f";
    tenantId = "d39bc9af-4689-4441-a40d-b11846f2af51";
    redirectUri = "https://higusa.insuredmine.com/agent/session/loginone";
}
else if (host == 'regencyins.insuredmine.com'){
    clientId = "85f4a8aa-eefa-4974-a804-16e4be1e4731";
    tenantId = "b38f13fb-d6cb-4177-85c2-dc45e8406375";
    redirectUri = "https://regencyins.insuredmine.com/agent/session/loginone";
}
else if (host == 'gillman.insuredmine.com') {
    clientId = "9be5ba4d-43f0-464d-99fb-5fddafdd26a9";
    tenantId = "b38f13fb-d6cb-4177-85c2-dc45e8406375";
    redirectUri = "https://gillman.insuredmine.com/agent/session/loginone";
}
else if (host == 'iwins.insuredmine.com') {
    clientId = "166d29b6-9e40-4d82-bd2b-858ab60b3e9d";
    tenantId = "3c0db452-b356-4691-adde-32861943b26f";
    redirectUri = "https://iwins.insuredmine.com/agent/session/loginone";
}
else if (host == 'qaagentportal.insuredmine.com'){
    clientId = "2fe1b422-7c33-4fc1-8e27-45512bee3023";
    tenantId = "770e7725-56ca-4480-935d-e8621263c85f";
    redirectUri = "https://qaagentportal.insuredmine.com/agent/session/loginone";
}

console.log('clientid: ', clientId);
console.log('tenantId: ', tenantId);
// gwic prodEnvironmentConfig ---end

const msalConfig = {
    auth: {
        //clientId: "3fba556e-5d4a-48e3-8e1a-fd57c12cb82e",
        //authority: "https://login.windows-ppe.net/common/"
        clientId: clientId,
        //authority: "https://login.windows.net/common/oauth2/authorize"
        authority: "https://login.microsoftonline.com/"+tenantId,
        redirectUri : redirectUri
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};  

// Add here scopes for id token to be used at MS Identity Platform endpoints.
const loginRequest = {
    scopes: ["User.Read"],
    redirectUri : redirectUri
};

// Add here the endpoints for MS Graph API services you would like to use.
const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft-ppe.com/v1.0/me",
    graphMailEndpoint: "https://graph.microsoft-ppe.com/v1.0/me/messages"
};

// Add here scopes for access token to be used at MS Graph API endpoints.
const tokenRequest = {
    scopes: ["Mail.Read"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

const silentRequest = {
    //scopes: ["3fba556e-5d4a-48e3-8e1a-fd57c12cb82e", "User.Read", "Mail.Read"]
    scopes: [clientId, "User.Read", "Mail.Read"]
    
};